import { render } from "./BaseChallengeCard.vue?vue&type=template&id=44b214d4&ts=true"
import script from "./BaseChallengeCard.vue?vue&type=script&lang=ts"
export * from "./BaseChallengeCard.vue?vue&type=script&lang=ts"

import "./BaseChallengeCard.vue?vue&type=style&index=0&id=44b214d4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__